.viewport {
  min-width: 0;
  overflow-x: auto;
  padding-block-start: var(--mtds-6);
}

.viewport > * {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  /* Line-chart labels and point hit areas extend past the first/last tick. */
  padding-inline: var(--mtds-6);
}
